import {Typography} from '@bonprix/design-system';
import {useCallback} from "react";
import NavigationTeaserImage from "./NavigationTeaserImage.jsx";
import Landmark from '@core/scripts/components/landmark-adapter';
import Url from '@core/scripts/helper/url.js';

const SALE = "SALE";
const WOW = "Wow!-Preise"; //nur für de und at gültig

export default function NavigationSecondLevel({secondLevelItems, selectSecondLevelItem, activeFirstLevelIndex}) {

    const handleSecondLevelClick = useCallback((index, item) => {
        const shopId = item.id
        const naviLmValue = `pn\\${shopId}\\\\`;
        Landmark.sendUserInterfaceLandmark({navi: naviLmValue});
        const subItems = item.subNavigationItems ?? [];
        const hasNoRealSubItems = item.overviewItem || subItems.length === 0 || subItems.every(sub => sub.overviewItem);
        if(hasNoRealSubItems) {
            window.location.href = item.url;
        } else {
            selectSecondLevelItem(shopId);
        }

    }, [selectSecondLevelItem]);

    const handleLinkClick = (event) => {
        event.preventDefault();
    }

    return (
        <div className="navigation__second-level">
            {secondLevelItems.map((item, index) => {
                const titleColor = item.fontColor || "primary";
                const handleClick = () => handleSecondLevelClick(index, item);

                return (
                    <div key={item.id} className="navigation__second-level-item" onClick={handleClick}>
                        <NavigationTeaserImage teaserImageSource={item.teaserImageSource}
                                               title={item.title} textVariant="bonprix-h5"/>
                        <a onClick={handleLinkClick} href={item.url} className="navigation__second-level-item-title">
                            <Typography variant="h5" component={'span'} color={titleColor}>{item.title}</Typography>
                        </a>
                    </div>
                );
            })}
        </div>
    );

}
;
